'use strict';

/**
 * Product Details Module
 */

var ImageGallery = require('./imageGallery');
var loyalty = require('./loyalty');
var breakpoints = require('../components/breakpoints');
var utils = require('../components/utils');
var base = require('./base');
var sizefitJs = require('../sizefit/sizefit');
var tabbedContainer = require('../aem/tabbedContainer');
var overflowSlider = require('../aem/overflowSlider');
var _ = require('underscore');
var pollWriteAReviewButtonInterval = 250;
var pollCountMax = 5;
var initialPageLoad = true;

/**
 * Make the Add to Cart Button Sticky
 */
function stickyAddToCart() {
    const $addToCartContainer = $('.add-to-cart__container');

    if ($addToCartContainer.length === 0 || breakpoints.isHighRes()) {
        return;
    }

    const containerOffsetTop = $addToCartContainer.offset().top;

    $(window)
        .off('scroll.stickyAddToCart')
        .on('scroll.stickyAddToCart', _.throttle(function () {
            const $mobileMenu = $('.js-siteheader-icons');
            let $clonedButton = $mobileMenu.find('.add-to-cart__container--clone');
            if ($(this).scrollTop() > containerOffsetTop) {
                if ($clonedButton.length) {
                    // the add to cart button has already been copied into the mobile menu
                    $clonedButton.show();
                } else {
                    // clone the add to cart button and insert it into the mobile menu
                    const isAddToCartOnlyContainer = $mobileMenu.hasClass('js-sticky-addtocart-container');
                    const STICKY_BUTTON_HEIGHT_LARGE = 50; // button height for add-to-cart-only container
                    const STICKY_BUTTON_HEIGHT_SMALL = 36; // button height for regular mobile menu
                    const STICKY_MENU_HEIGHT = 72; // menu height for add-to-cart-only container
                    const btnHeight = isAddToCartOnlyContainer ? STICKY_BUTTON_HEIGHT_LARGE : STICKY_BUTTON_HEIGHT_SMALL; // desired button height
                    const menuHeight = isAddToCartOnlyContainer ? STICKY_MENU_HEIGHT : $mobileMenu.height();
                    const my = (menuHeight - btnHeight) / 2;
                    $clonedButton = $addToCartContainer.clone(true, true)
                        .addClass('add-to-cart__container--clone flex-grow-1')
                        .css({
                            height: btnHeight,
                            margin: `${my}px 1rem`
                        });
                    $clonedButton.find('button.add-to-cart').addClass('px-5 py-0').css('height', btnHeight);
                    $clonedButton.find('.js-exclusive-access-text').remove();
                    $mobileMenu.append($clonedButton);
                }
                // hide some icons to make room for the sticky add to cart button
                $mobileMenu.find('.js-header-search-icon, .js-action__account, .chat').hide();
            } else {
                $clonedButton.hide();
                // show the icons again
                $mobileMenu.find('.js-header-search-icon, .js-action__account, .chat').show();
            }
        }, 100));
}

/**
 * Klarna Placements
 * The data.price object does not always contain the price that is displayed on the page,
 * So to get the displayed price, we'll scrape it from the page.
 */
function refreshKlarnaPlacements() {
    var displayedPrice = $('.prices .value:first').attr('content'); // content attribute is the unformatted value.
    var klarnaPriceValue = displayedPrice ? Math.round(displayedPrice * 100) : 1;
    $('klarna-placement').attr('data-purchase-amount', klarnaPriceValue); // CAN NOT USE .data() HERE. Gotta update the attribute directly.
    if (window.Klarna && window.Klarna.OnsiteMessaging) {
        window.Klarna.OnsiteMessaging.refresh();
    }
}

/**
 * Update Product Attributes and Details
 */
function updateAttributesAndDetails() {
    $('body').on('product:statusUpdate', function (e, data) {
        /**
         * Get a reference to the product container
         */
        var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

        /**
         * Product Description and Details
         */
        $productContainer.find('.description-and-detail .product-attributes')
            .empty()
            .html(data.attributesHtml);

        if (data.shortDescription) {
            $productContainer.find('.description-and-detail .description')
                .removeClass('hidden-xl-down');
            $productContainer.find('.description-and-detail .description .content')
                .empty()
                .html(data.shortDescription);
        } else {
            $productContainer.find('.description-and-detail .description')
                .addClass('hidden-xl-down');
        }

        if (data.longDescription) {
            $productContainer.find('.description-and-detail .details')
                .removeClass('hidden-xl-down');
            $productContainer.find('.description-and-detail .details .content')
                .empty()
                .html(data.longDescription);
        } else {
            $productContainer.find('.description-and-detail .details')
                .addClass('hidden-xl-down');
        }

        /**
         * Product In-Store Pickup
         */
        var $inStorePickupContainer = $('.product-detail .product-instore__inventory');

        if ($inStorePickupContainer.length > 0) {
            if (data.availableForInStorePickup) {
                $inStorePickupContainer.removeClass('d-none');
            } else {
                $inStorePickupContainer.addClass('d-none');
            }
        }

        /**
         * Klarna Placements
         */
        refreshKlarnaPlacements();
    });
}

/**
 * Show the Spinner
 */
function showSpinner() {
    if (window.resources.enableServerSideGallery) {
        $('body').on('product:beforeAddToCart', function () {
            $.spinner().start();
        });
    } else {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
            $.spinner().start();
        });
    }
}

/**
 * Update Product Attributes
 */
function updateAttribute() {
    $('body').on('product:afterAttributeSelect', function (e, response) {
        if ($('.product-detail>.bundle-items').length) {
            $(response.container).data('pid', response.data.product.id);
            $(response.container).find('.product-id')
                .data('pid', response.data.product.id)
                .text(response.data.product.masterId);
        } else if ($('.product-set-detail').eq(0)) {
            $(response.container).data('pid', response.data.product.id);
            $(response.container).find('.product-id')
                .data('pid', response.data.product.id)
                .text(response.data.product.masterId);
        } else {
            $('.product-id').data('pid', response.data.product.id)
                .text(response.data.product.masterId);
            $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
        }
    });
}

/**
 * Update the Add To Cart Button
 */
function updateAddToCart() {
    $('body').on('product:updateAddToCart', function (e, response) {
        // update local add to cart (for sets)
        if (response.product.readyToOrder && !response.product.available) {
            $('.js-product__message--partners').show();
        }

        if (base.isEverythingSelected()) {
            $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').attr('disabled', false);
        }

        // Upon initial load, products are not ready for order because a size isn't selected (unless O/S or only one size in stock).
        // At that time, the button to add to cart should be enabled until the customer clicks it.
        // After that, the button should disabled and the customer should follow displayed messaging regarding making a selection.
        const disableAddToCart = !response.product.available || (!response.product.readyToOrder && !initialPageLoad);
        $('button.add-to-cart, button.update-cart-product-global', response.$productContainer)
            .attr('disabled', disableAddToCart)
            .text(response.product.buttonText);

        if (disableAddToCart) {
            initialPageLoad = false;
        }

        let enable = $('.product-availability').toArray().every(function (item) {
            return $(item).data('available') && $(item).data('ready-to-order');
        });

        if (enable) {
            $('.js-product__message--partners').hide();
        }
    });
}

/**
 * Update Product Availability
 */
function updateAvailability() {
    $('body').on('product:updateAvailability', function (e, response) {
        $('div.availability', response.$productContainer)
            .data('ready-to-order', response.product.readyToOrder)
            .data('available', response.product.available);

        // Might need to preface with div.availability
        const $availabilityMsgContainer = $('.availability-msg', response.$productContainer).toggleClass('d-none', !response.message);

        if (response.availabilityMessages && response.availabilityMessages.length) {
            response.availabilityMessages.forEach(message => {
                $availabilityMsgContainer.alert({
                    content: message.content,
                    theme: message.theme,
                    dismissible: false,
                    autoClose: false
                });
            });
        }

        $('.product__message--velocity', response.$productContainer)
            .empty()
            .html(response.velocityMessage);

        $('.selectswatch-' + response.selectedAttributeID + '-msg', response.$productContainer).removeClass('d-inline').addClass('d-none');

        $('.outofstock-combination-msg', response.$productContainer);

        if (response.product.notifyme && !response.product.isMaster) {
            $('.product__add-to-cart', response.$productContainer).hide();
            $('.product__notify-me', response.$productContainer).show();
            $('.product__message--velocity', response.$productContainer).addClass('product__message--velocity--notifyme').show();
            $('.outofstock-combination-msg', response.$productContainer).show();
            $('input[name=variantPID]', response.$productContainer).val(response.product.id);
        } else {
            $('.product__add-to-cart', response.$productContainer).show();
            $('.product__notify-me', response.$productContainer).hide();
            $('input[name=variantPID]', response.$productContainer).val('');

            // Display inventory threshold message
            if (response.velocityMessage !== '') {
                $('.product__message--velocity', response.$productContainer).removeClass('product__message--velocity--notifyme').show();
            }
        }

        if ($('.global-availability').length) {
            // This is used for a Product Bundles and Product Sets. Checks all the
            // sub-products for Available and Ready. If all selected variants are
            // selected, then update the global-availability data.
            var allAvailable = $('.product-availability').toArray()
                .every(function (item) { return $(item).data('available'); });

            var allReady = $('.product-availability').toArray()
                .every(function (item) { return $(item).data('ready-to-order'); });

            $('.global-availability')
                .data('ready-to-order', allReady)
                .data('available', allAvailable);

            $('.global-availability .availability-msg').empty(); // response.resources.info_selectforstock

            if (response.availabilityMessages && response.availabilityMessages.length) {
                response.availabilityMessages.forEach(message => {
                    $availabilityMsgContainer.alert({
                        content: message.content,
                        theme: message.theme,
                        dismissible: false,
                        autoClose: false
                    });
                });
            }
        }
        $('.accordion').trigger('collapse-changed'); // Refresh hc-sticky to avoid ovelaping content
        $('body').trigger('product:checkOutOfStock', response);
    });
}

/**
 * Scroll the viewport to the a given accordion section
 *
 * @param {string} sectionSelector - Accordian Section to scroll to
 * @param {JQuery} $productDetailsContainer - Reference to product detail container
 */
function scrollToAccordionSection(sectionSelector, $productDetailsContainer) {
    var $productAccordianDrawer = $productDetailsContainer.find(sectionSelector);

    if ($productAccordianDrawer.length) {
        $productAccordianDrawer.collapse('show');

        var headerHeight = $('.js-site-header').height();

        $('html, body').animate({
            scrollTop: $productAccordianDrawer.closest('.accordion__section').offset().top - headerHeight - 10
        }, 300);
    }
}

/**
 * Initialize the Image Gallery
 */
function initGallery() {
    const swiperImageGallery = new ImageGallery();
    swiperImageGallery.init();
}

/**
 * Hide Size Fit Modal
 */
var hideSizeFitModal = () => {
    $('.sizefit-modal').remove(); // this class is added to the modal when it is created, in createQVModal().
    // also remove the backdrop
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open').css('padding-right', '');
    $.enableScroll();
    $(window).trigger('scroll');
};

/**
 * Create Modal for SizeFIt Guide
 * @returns {HTMLElement} $modal - Reference to modal JQuery object
 */
var createSizeFitModal = () => {
    var isMobile = breakpoints.isLowRes();
    var modalConfig = {
        customClasses: 'sizefit-modal'
    };
    if (isMobile) {
        modalConfig.centeredClass = 'modal-dialog-centered modal-dialog-scrollable banner-size-fit';
    }
    let modalMarkup = utils.createModalMarkup('', modalConfig);
    let $modal = $(modalMarkup).modal();
    $modal.on('hidden.bs.modal', () => {
        hideSizeFitModal();
    });
    return $modal;
};

/**
 * Fetches sizefitguide html from server and launches modal
 * @param {string} sizeGuideUrl  - SizeFit Guide view controller endpoint url
 * @param {HTMLElement} $modal - Reference to modal JQuery object
 */
var launchSizeGuide = (sizeGuideUrl, $modal) => {
    if (!sizeGuideUrl) {
        return;
    }

    if (!$modal) {
        $modal = createSizeFitModal(); // eslint-disable-line no-param-reassign
    }

    $modal.modal('show');
    $.spinner().start();

    let successHandler = (html, unitType) => {
        $modal.find('.modal-body').html(html);
        tabbedContainer.init();
        overflowSlider();
        if (window.ssp) {
            window.ssp('start', 'fitpredictor');
        }
        if (sizeGuideUrl.indexOf('GarmentGuide') > -1) {
            var sizefitSwitch = $modal.find('.js-garment-sizefit');
            var toggleHTML = `<div class="d-block">
                <div class="d-flex justify-content-end">
                    <button class="js-unit-toggle toggle-btn px-3 pb-3 pt-0 ${unitType} btn">
                        <span>
                            IN
                            <svg class="toggle-in align-bottom" width="24" height="24"><use href="${'#'}toggle_off"></use></svg>
                            <svg class="toggle-cm align-bottom" width="24" height="24"><use href="${'#'}toggle_on"></use></svg>
                            CM
                        </span>
                    </button>
                </div>
            </div>`;
            sizefitSwitch.html(toggleHTML);
        }
        sizefitJs.initSizeFit();
    };

    $.ajax({
        url: sizeGuideUrl,
        method: 'GET',
        dataType: 'json',
        success: (data) => {
            if (!$modal[0].parentElement) {
                // success was called before the modal is shown.
                $modal.on('shown.bs.modal', () => {
                    successHandler(data.renderedTemplate, data.unitType);
                });
            } else {
                successHandler(data.renderedTemplate, data.unitType);
            }
        },
        complete: () => {
            $.spinner().stop();
            $.disableScroll();
        },
        error: () => {
            hideSizeFitModal();
        }
    });
};

/**
 * Sets Out of Stock status text based on the selectable/unselectable state of the attribute
 * @param {jQuery} $swatchEntered  - targeted swatch on click/hover
 * @param {string} selectedValue - selected text value
 * @param {jQuery} $attributeLabelValue - selected text element
 * @param {jQuery} $auxSwatch optional parameter that indicates an auxiliary swatch should be updated
 */
function setSelectedInventoryStatus($swatchEntered, selectedValue, $attributeLabelValue, $auxSwatch) {
    const outOfStockText = $swatchEntered.closest('[data-attr-oos-text]').data('attr-oos-text');

    if (selectedValue !== undefined) {
        if ($swatchEntered.hasClass('unselectable')) {
            $attributeLabelValue.text(selectedValue + ' ' + outOfStockText).addClass('text-danger');
            if ($auxSwatch) {
                $auxSwatch.attr('data-attr-oos', outOfStockText);
            } else {
                $swatchEntered.attr('data-attr-oos', outOfStockText);
            }
        } else {
            $attributeLabelValue.text(selectedValue).removeClass('text-danger');
            if ($auxSwatch) {
                $auxSwatch.attr('data-attr-oos', '');
            } else {
                $swatchEntered.attr('data-attr-oos', '');
            }
        }
    }
}

/**
 * Custom events on Attribute click and hover
 */
function onSelectAttribute() {
    // Color Attribute click event to display selected/selectable status
    $('.js-product-content').on('attribute:click', '.js-color-swatch, .js-size-swatch, .js-dimension-swatch', function (e) {
        const $swatchClicked = $(e.currentTarget);
        const attrType = $swatchClicked.closest('.js-attribute').data('attr');
        const $attrValue = $swatchClicked.closest('.js-attribute').find('.js-attr-label-value');
        let selectedValue;

        if (attrType === 'color') {
            selectedValue = $swatchClicked.find('.color-value').attr('title');
        } else {
            const $selectedColorSwatch = $('.js-attribute-color .js-color-swatch.selected');
            const $colorValue = $selectedColorSwatch.closest('.js-attribute').find('.js-attr-label-value');
            const colorSelected = $selectedColorSwatch.find('.color-value').attr('title');
            selectedValue = $swatchClicked.data('attr-hover');

            // Color label may also need to be updated to reflect inventory status when a size/dimension swatchis selected
            setSelectedInventoryStatus($swatchClicked, colorSelected, $colorValue, $selectedColorSwatch);
        }

        setSelectedInventoryStatus($swatchClicked, selectedValue, $attrValue);
    });

    // Attribute Select event to get the new attribute selected/selectable status for Size/Dimension attributes
    $(document).on('attribute:select', '.product-detail .js-size-swatch, .product-detail .js-dimension-swatch', function (e, $attrValue, attrValue) {
        const outOfStockText = $attrValue.closest('[data-attr-oos-text]').data('attr-oos-text');
        const attributeLabelValue = $attrValue.closest('.js-attribute').find('.js-attr-label-value');
        attributeLabelValue.text($attrValue.data('attr-hover'));
        if (!attrValue.selectable) {
            attributeLabelValue.addClass('text-danger').text($attrValue.data('attr-hover') + ' ' + outOfStockText);
            $attrValue.attr('data-attr-oos', outOfStockText);
        } else {
            attributeLabelValue.removeClass('text-danger').text($attrValue.data('attr-hover'));
            $attrValue.attr('data-attr-oos', '');
        }
    });
}

/**
 * Poll to see when the write a review button loads in the ratings and reviews accordion section.
 *  - activate by setting url param: bvOpenWriteReview=true
 */
function onWriteReviewButtonPoll() {
    var pollCallback = function () {
        var queryString = utils.getParamsFromURL(window.location.search);

        if (queryString && queryString.bvOpenWriteReview && queryString.bvOpenWriteReview === 'true') {
            if (pollCountMax > 0) {
                pollCountMax -= 1;
                var $button = $('.bv-write-review.bv-submission-button:button');
                if ($button.length === 1) {
                    $button.click();
                } else {
                    setTimeout(pollCallback, pollWriteAReviewButtonInterval);
                }
            }
        }
    };

    setTimeout(pollCallback, pollWriteAReviewButtonInterval);
}

/**
 * Method to observe review drawer and check if any comments are added
 */
function observeReviewDrawer() {
    const $targetNode = $('.js-review-drawer')[0];
    const config = { attributes: true, childList: true, subtree: true };
    const observer = new MutationObserver(function (mutationsList) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                if ($('.js-review-drawer').find('ol li').length >= 1) {
                    var $bvReviewRatings = $('.js-true-to-size');
                    if ($bvReviewRatings.length) {
                        $bvReviewRatings.removeClass('d-none');
                        observer.disconnect();
                    }
                }
            }
        }
    });
    // Start observing the target node for configured mutations
    if ($targetNode) {
        observer.observe($targetNode, config);
    }
}

/**
 * Ensure proper formatting of global process variable
 */
function enforceGlobalProcessFormatting() {
    let internalProcessValue;
    let processCopy = window.process; // get initial process value if it exists

    /**
     * Checks if param is an object
     * @param {*} param to check type of
     * @returns {boolean} if param is an object
     */
    function isObject(param) {
        return typeof param === 'object' && param !== null && !Array.isArray(param);
    }

    Object.defineProperty(window, 'process', {
        get: function () {
            if (typeof internalProcessValue === 'undefined') { // if value not previously set
                const processValue = isObject(processCopy) ? processCopy : {}; // process must be an object
                processValue.env = isObject(processValue.env) ? processValue.env : {}; // process.env must be an object

                internalProcessValue = processValue;
            }

            return internalProcessValue;
        },
        set: function (param) {
            processCopy = isObject(processCopy) ? processCopy : {}; // process must be an object
            const processParam = isObject(param) ? param : {}; // process must be an object
            const processValue = Object.assign({}, processCopy, processParam); // combine existing and new process properties
            processValue.env = isObject(processValue.env) ? processValue.env : {}; // process.env must be an object

            processCopy = processValue; // update copied process value
            internalProcessValue = processValue;
        }
    });
}

/**
 * PLEASE NOTE
 * THE FOLLOWING METHODS HAVE BEEN INCLUDED GLOBALLY IN product/pdpActions.js FOR QUICKVIEW,
 * SO NO NEED TO INCLUDE THEM HERE
 *
 * selectAttribute: base.selectAttribute,
 * availabilty: base.avaliability,
 * addToCart: base.addToCart,
 **/

module.exports = {
    /**
     * This is necessary for page load if the product variant is already selected.
     *
     * Edit productDetails.isml to add the master ID
     *
     *
     * Check Quick View
     *
     *
     * Also check to make sure everything is selected
     *
     * Check Gift Card
     *
     * * Check to see if the data-pid is the same as the master id, if it is do the following:
     *
     * may only need to call attributeSelect once, pick the first and then fire
     *
     */
    init: function () {
        const $productContainer = $('.product-detail');
        const $dimensionSwatchSelected = $('.product__attributes .js-dimension-swatch.selected.selectable');
        const $sizeSwatchSelected = $('.product__attributes .js-size-swatch.selected');
        const $selectedColorSwatch = $('.js-attribute-color .js-color-swatch.selected');
        const $colorValue = $selectedColorSwatch.closest('.js-attribute').find('.js-attr-label-value');
        const colorSelected = $selectedColorSwatch.find('.color-value').attr('title');
        const queryScOnLoad = utils.getParamsFromURL(window.location.search);

        observeReviewDrawer();

        if (queryScOnLoad && queryScOnLoad.scOnLoad && queryScOnLoad.scOnLoad.toUpperCase() === 'Y') {
            launchSizeGuide($('.js-sizeguide-modal').attr('data-link'), '');
        }

        if ($productContainer.data('pid') === $productContainer.data('master-pid')) {
            if (base.isEverythingSelected()) {
                const $swatchSelected = $('.product__attributes a.selected').first();
                const selectedAttributeID = $swatchSelected.closest('.js-attribute').data('attr');

                base.attributeSelect($swatchSelected.data('attr-url'), $productContainer, selectedAttributeID);
            } else if ($dimensionSwatchSelected.length && !$sizeSwatchSelected.length) {
                base.attributeSelect($dimensionSwatchSelected.data('attr-url'), $productContainer, 'dimension');
            }
        }

        // Refresh Product-Variation data based on initial selection
        if ($productContainer.data('availability-refresh')) {
            var customValueUrl = $('.js-color-swatch.selected').data('attr-url');
            base.attributeSelect(customValueUrl, $productContainer, 'inventory');
        }

        base.updateOOSColorVariants($productContainer);
        setSelectedInventoryStatus($sizeSwatchSelected, colorSelected, $colorValue, $selectedColorSwatch);
        refreshKlarnaPlacements();

        // Flag swatches to indicate notify me status (see base.forceOOSNotifyMe)
        base.setVariantNotifyMeStatus();


        $(window).on('breakpoint:changed', function (e, data) {
            if (['lg', 'xl', '2xl'].includes(data.currentBp)) {
                // desktop
                $('.add-to-cart__container--clone').remove();
                const $mobileMenu = $('.js-siteheader-icons');
                $mobileMenu.find('.js-header-search-icon, .js-action__account, .chat').show();
                $(window).off('scroll.stickyAddToCart');
            } else {
                // mobile
                stickyAddToCart();
            }
        });
    },
    initProcess: enforceGlobalProcessFormatting,
    stickyAddToCart: stickyAddToCart,
    updateAttributesAndDetails: updateAttributesAndDetails,
    showSpinner: showSpinner,
    updateAttribute: updateAttribute,
    updateAddToCart: updateAddToCart,
    updateAvailability: updateAvailability,
    onScrollToDetails: () => {
        $(document).on('click', '.js-view-details-jumplink', function (e) {
            e.preventDefault();
            var $productDetailsContainer = $(this).closest('.product-detail');
            scrollToAccordionSection('#product-accordion-details', $productDetailsContainer);
        });
    },
    initGallery: function () {
        initGallery();

        $(document).on('product:swiper:update', function () {
            initGallery();
        });
    },
    initLoyalty: loyalty.init,
    onClickReviewStars: function () {
        $(window).on('load', function () {
            $(document).on('click', '.product-detail .ratings, .js-accordion-reviews, .true-to-size, .bv_modal_component_container .bv_button_buttonFull', function (e) {
                e.preventDefault();
                var $productDetailsContainer = $(this).closest('.product-detail');
                if (!$productDetailsContainer.length) {
                    $productDetailsContainer = $('.product-detail');
                }
                scrollToAccordionSection('#product-accordion-reviews', $productDetailsContainer);
            });
            // Reviews Drawer should be open on page load while clicking review rating from product list page.
            var queryParamProductReviews = utils.getParamsFromURL(window.location.search);
            if (queryParamProductReviews && queryParamProductReviews.bvOpen && queryParamProductReviews.bvOpen.toUpperCase() === 'TRUE') {
                scrollToAccordionSection('#product-accordion-reviews', $('.product-detail'));
            }
        });
    },
    launchOmnibusReviewModal: function () {
        $('body')
            .off('click keydown', '.js-omnibus-review-msg')
            .on('click keydown', '.js-omnibus-review-msg', (e) => {
                if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
                    return;
                }

                e.preventDefault();

                const $this = $(e.currentTarget);
                const modalTitle = $this.data('message-title');
                const modalContent = $this.data('message-content');
                $.modal({
                    title: modalTitle,
                    content: modalContent,
                    modalSizeClass: 'modal-md modal-pad-fix'
                });
            });
    },
    launchSizeGuideModal: function () {
        $('body')
            .off('click', '.js-sizeguide-modal')
            .on('click', '.js-sizeguide-modal', (e) => {
                e.preventDefault();
                let $this = $(e.currentTarget);
                let $modal = createSizeFitModal();
                launchSizeGuide($this.data('link'), $modal);
            });
    },
    onSelectAttribute: onSelectAttribute,
    onWriteReviewButtonPoll: onWriteReviewButtonPoll,
    forceOOSNotifyMe: base.forceOOSNotifyMe
};
